// Jauge SVG en arc tronqué (style speedometer, 240° couverts)
// 3 segments : bonnes réponses | timeouts | mauvaises réponses
// Chip de statut intégrée quand size >= 150 et total > 0
export default function ArcGauge({ correctes = 0, timeouts = 0, incorrectes = 0, total = 0, size = 198 }) {
  const R = 48, CX = 60, CY = 60
  const circumference = 2 * Math.PI * R
  const arcLength = circumference * (240 / 360)
  const taux = total > 0 ? Math.round(correctes / total * 100) : 0

  const color     = taux >= 70 ? '#22c55e' : taux >= 50 ? '#f59e0b' : '#ef4444'
  const textColor = taux >= 70 ? '#86efac' : taux >= 50 ? '#fcd34d' : '#fca5a5'

  const lenCorrect   = total > 0 ? arcLength * (correctes  / total) : 0
  const lenTimeout   = total > 0 ? arcLength * (timeouts   / total) : 0
  const lenIncorrect = total > 0 ? arcLength * (incorrectes / total) : 0

  function segProps({ len, start }) {
    return {
      strokeDasharray:  `${len} ${circumference - len}`,
      strokeDashoffset: circumference - start,
    }
  }

  const transform = `rotate(150, ${CX}, ${CY})`
  const viewBoxHeight = 90
  const svgHeight = Math.round(size * viewBoxHeight / 120)

  const textY     = total === 0 ? 65 : 60
  const chipLabel = taux >= 75 ? 'Maîtrisé' : taux >= 50 ? 'Acquis' : 'À réviser'
  const chipBg    = taux >= 75 ? '#22c55e' : taux >= 50 ? '#f59e0b' : '#ef4444'
  const chipH     = 14
  const chipW     = chipLabel.length * 6 + 10
  const chipX     = CX - chipW / 2
  const chipY     = textY + 3
  const showChip  = total > 0 && size >= 150

  return (
    <svg width={size} height={svgHeight} viewBox={`0 0 120 ${viewBoxHeight}`} className="shrink-0">
      <circle cx={CX} cy={CY} r={R} fill="none" stroke="white" strokeOpacity={0.12} strokeWidth={10}
        strokeDasharray={`${arcLength} ${circumference - arcLength}`} strokeDashoffset={circumference}
        transform={transform} strokeLinecap="butt" />
      {lenIncorrect > 0 && (
        <circle cx={CX} cy={CY} r={R} fill="none" stroke="#374151" strokeWidth={10}
          {...segProps({ len: lenIncorrect, start: lenCorrect + lenTimeout })}
          transform={transform} strokeLinecap="butt" />
      )}
      {lenTimeout > 0 && (
        <circle cx={CX} cy={CY} r={R} fill="none" stroke="#e2e8f0" strokeWidth={10}
          {...segProps({ len: lenTimeout, start: lenCorrect })}
          transform={transform} strokeLinecap="butt" />
      )}
      {lenCorrect > 0 && (
        <circle cx={CX} cy={CY} r={R} fill="none" stroke={color} strokeWidth={10}
          {...segProps({ len: lenCorrect, start: 0 })}
          transform={transform} strokeLinecap="butt" />
      )}
      <text x={CX} y={textY} textAnchor="middle" fontSize={total === 0 ? 14 : 22} fontWeight="600"
        fill={total === 0 ? 'rgba(255,255,255,0.3)' : textColor}>
        {total === 0 ? '—' : `${taux}%`}
      </text>
      {showChip && (
        <g>
          <rect x={chipX} y={chipY} width={chipW} height={chipH} rx={chipH / 2} fill={chipBg} />
          <text x={CX} y={chipY + chipH / 2} textAnchor="middle" dominantBaseline="central"
            fontSize={10} fontWeight="600" fill="white">
            {chipLabel}
          </text>
        </g>
      )}
    </svg>
  )
}
